import { c as _c } from "react/compiler-runtime";
import { useVisitorData } from "@fingerprintjs/fingerprintjs-pro-react";
import { useMemo } from "react";
import { useCoinbaseOnrampOptions } from "./useCoinbaseOnrampOptions.js";
import { useGetGeo } from "./useGetGeo.js";
import { useStripeSupport } from "./useStripeSupport.js";
export function useGeoOnrampOptions(srcFiatAmount) {
  const $ = _c(25);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      extendedResult: true
    };
    t1 = {
      immediate: true
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const {
    data: fpData,
    isLoading: isLoadingVisitorData
  } = useVisitorData(t0, t1);
  let t2;
  if ($[2] !== fpData) {
    t2 = fpData && {
      requestId: fpData.requestId,
      visitorId: fpData.visitorId
    };
    $[2] = fpData;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const visitorData = t2;
  const {
    geoData,
    loading: isLoadingGeo,
    error: geoError
  } = useGetGeo();
  const {
    coinbaseOnrampOptions,
    isLoadingCoinbaseOnrampOptions,
    coinbaseOnrampOptionsError
  } = useCoinbaseOnrampOptions(geoData?.country, visitorData);
  const {
    stripeOnrampSupport,
    stripeWeb2Support,
    isLoadingStripeSupport,
    stripeSupportError
  } = useStripeSupport(srcFiatAmount, visitorData);
  let t3;
  bb0: {
    if (!coinbaseOnrampOptions?.paymentCurrencies?.[0]?.limits || !srcFiatAmount) {
      let t4;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[4] = t4;
      } else {
        t4 = $[4];
      }
      t3 = t4;
      break bb0;
    }
    const amountNum = parseFloat(srcFiatAmount);
    if (isNaN(amountNum)) {
      let t4;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      t3 = t4;
      break bb0;
    }
    let t4;
    if ($[6] !== amountNum || $[7] !== coinbaseOnrampOptions.paymentCurrencies[0].limits) {
      let t5;
      if ($[9] !== amountNum) {
        t5 = limit => {
          const min = parseFloat(limit.min);
          const max = parseFloat(limit.max);
          return amountNum >= min && amountNum <= max;
        };
        $[9] = amountNum;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      t4 = coinbaseOnrampOptions.paymentCurrencies[0].limits.filter(t5);
      $[6] = amountNum;
      $[7] = coinbaseOnrampOptions.paymentCurrencies[0].limits;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = t4;
  }
  const coinbaseAvailablePaymentMethods = t3;
  let t4;
  const t5 = coinbaseAvailablePaymentMethods.length > 0 || stripeOnrampSupport || stripeWeb2Support.isSupport;
  const t6 = isLoadingGeo || isLoadingCoinbaseOnrampOptions || isLoadingStripeSupport || isLoadingVisitorData;
  let t7;
  if ($[11] !== coinbaseAvailablePaymentMethods || $[12] !== coinbaseOnrampOptions || $[13] !== coinbaseOnrampOptionsError || $[14] !== geoData || $[15] !== geoError || $[16] !== isLoadingCoinbaseOnrampOptions || $[17] !== isLoadingGeo || $[18] !== isLoadingStripeSupport || $[19] !== stripeOnrampSupport || $[20] !== stripeSupportError || $[21] !== stripeWeb2Support || $[22] !== t5 || $[23] !== t6) {
    t7 = {
      geoData,
      coinbaseOnrampOptions,
      coinbaseAvailablePaymentMethods,
      stripeOnrampSupport,
      stripeWeb2Support,
      isOnrampSupported: t5,
      isLoading: t6,
      isLoadingGeo,
      isLoadingCoinbaseOnrampOptions,
      isLoadingStripeSupport,
      geoError,
      coinbaseOnrampOptionsError,
      stripeSupportError
    };
    $[11] = coinbaseAvailablePaymentMethods;
    $[12] = coinbaseOnrampOptions;
    $[13] = coinbaseOnrampOptionsError;
    $[14] = geoData;
    $[15] = geoError;
    $[16] = isLoadingCoinbaseOnrampOptions;
    $[17] = isLoadingGeo;
    $[18] = isLoadingStripeSupport;
    $[19] = stripeOnrampSupport;
    $[20] = stripeSupportError;
    $[21] = stripeWeb2Support;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  t4 = t7;
  return t4;
}